import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Select, Tooltip, Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { IotaMetadataInput } from '../../types';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { InternalSelectOption } from '../../types';
import ProjectApplicationDefinitionsSourcesStore from '../../stores/ProjectApplicationDefinitionsSourcesStore';

const parameters = {
    optionsType: 'optionsType'
} as const;

interface Props {
    form: FormInstance;
    input: IotaMetadataInput;
    initialValue: unknown;
    sourcesStore: ProjectApplicationDefinitionsSourcesStore;
    disabled?: boolean;
}

const ApplicationInternalSelectInput: React.FC<Props> = ({ input, initialValue, sourcesStore, disabled = false }) => {
    const inputValues = React.useMemo(() => input.values ?? {}, [input.values]);

    const optionsType = inputValues[parameters.optionsType];

    const { internalSelectOptions } = sourcesStore;

    const options: InternalSelectOption[] = React.useMemo(
        () => internalSelectOptions[optionsType] ?? [],
        [optionsType, internalSelectOptions]
    );

    return (
        <Form.Item
            name={input.id}
            initialValue={initialValue}
            label={
                <span>
                    {input.name}&nbsp;
                    <Tooltip title={input.description}>
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
        >
            <Select
                options={options}
                loading={sourcesStore.isLoading}
                disabled={disabled}
                showSearch
                filterOption={(inputText, option) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().includes(inputText.toLowerCase())
                }
            />
        </Form.Item>
    );
};

export default observer(ApplicationInternalSelectInput);
